<div *ngIf="artist" class="artistView">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/collection" data-ta-name="artistsLink">Artists</a></li>
      <li class="breadcrumb-item active" aria-current="page" data-ta-name="artistNameInBreadcrumb">{{artist.name}}</li>
    </ol>
  </nav>
  <h1 class="artistName" data-ta-name="artistName">{{artist.name}}</h1>
  <div class="artistImageAndSummaryContainer">
    <img [src]="getArtistImg(artist.id)"
         class="artistImage"
         onerror="this.src='https://dummyimage.com/400x250/ccc/000.jpg&text=Not+Available'">
    <div class="artistSummaryContainer">
      <div [innerHTML]="getArtistDescription(artist.description)" data-ta-name="artistNotes"></div>
      <div *ngIf="albums">
        <div *ngIf="placeToStart">
          <h5 *ngIf="placeToStart.length !== 0">Place to Start</h5>
          <div *ngFor="let album of placeToStart">
            <a routerLink="/artist/{{artist.id}}/album/{{album.id}}" data-ta-name="placeToStartLink">{{album.name}}</a>
            <br>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="albums">
    <div class="albumsHeadingAndControlsContainer">
      <h2>Albums <small class="text-muted">({{albums.albumSummaries.length}})</small></h2>
      <div class="albumViewControls">
        <span *ngIf="albumViewIsCard()">Card View</span>
        <a *ngIf="!albumViewIsCard()" (click)="viewCards()" href="javascript:void(0)" data-ta-name="cardViewLink">Card View</a>
        |
        <span *ngIf="albumViewIsTable()">Table View</span>
        <a *ngIf="!albumViewIsTable()" (click)="viewTable()" href="javascript:void(0)" data-ta-name="tableViewLink">Table View</a>
      </div>
    </div>
    <div *ngIf="albumViewIsCard()">
      <app-albums-card [albums]="albums" [artist]="artist"></app-albums-card>
    </div>
    <div *ngIf="albumViewIsTable()">
      <app-albums-table [albums]="albums" [artist]="artist"></app-albums-table>
    </div>
  </div>
</div>
<app-artist-navigation-navbar [artist]="artist"></app-artist-navigation-navbar>
